exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yC1ulqPTFEm3nlhq_l3_M {\n  padding: 10px;\n  max-width: 480px;\n  margin: auto;\n}\n\n._1d86BqPSJhGDkfOkufiq_- {\n  align-items: flex-end;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  overflow: hidden;\n}\n\n._1tJJrRDob4NpGwZ2yJE2KM {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"MainContainer": "yC1ulqPTFEm3nlhq_l3_M",
	"ControlsContainer": "_1d86BqPSJhGDkfOkufiq_-",
	"Box": "_1tJJrRDob4NpGwZ2yJE2KM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib??ref--1-1!./styles/Layout.css
// module id = 206
// module chunks = 0